import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../constants/animationVariants';

const ApplicationSectionWrapper = ({
  sectionTitle,
  children,
}: {
  sectionTitle: string;
  children: React.ReactNode;
}) => {
  // rendering application section wrapper component here
  return (
    <motion.section
      variants={sectionAnimVariants}
      initial='initial'
      animate='animate'
      onAnimationStart={() =>
        document.documentElement.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
      className='relative space-y-5 border-2 border-legal-dark-blue border-dashed p-3 md:p-5 rounded-xl mt-10'
    >
      <h3 className='absolute -top-8 md:-top-10 translate-y-1/2 text-2xl md:text-3xl bg-base-white px-2 text-legal-dark-blue capitalize italic'>
        {sectionTitle}
      </h3>
      {children}
    </motion.section>
  );
};

export default ApplicationSectionWrapper;
